import { render, staticRenderFns } from "./side-tabs.vue?vue&type=template&id=69f73546&"
import script from "./side-tabs.vue?vue&type=script&lang=js&"
export * from "./side-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports